import {
  FileUploadStart,
  FileUploadSuccess,
  FileUploadError,
  FILE_UPLOAD_START,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_ERROR,
  SELECT_FILES,
  REMOVE_FILES,
  SELECT_SINGLE_FILE,
  REMOVE_SINGLE_FILE,
  SelectFiles,
  RemoveFiles,
  SelectSingleFile,
  RemoveSingleFile
} from './types';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { ApplicationState } from '../types';
import { FORM_CONTAINER_NAME } from '../../constants';

function fileUploadStart(): FileUploadStart {
  return {
    type: FILE_UPLOAD_START
  };
}

function fileUploadSuccess(): FileUploadSuccess {
  return { type: FILE_UPLOAD_SUCCESS };
}

function fileUploadError(): FileUploadError {
  return {
    type: FILE_UPLOAD_ERROR
  };
}

export function uploadFile(
  files: ReadonlyArray<any>
): ThunkAction<void, ApplicationState, null, Action<string>> {
  return async (dispatch, getState) => {
    const state = getState();

    if (!state.wizard.schema || !state.wizard.schema.uploadAction) {
      return;
    }

    const uploadAction = state.wizard.schema.uploadAction;
    const values = state.form[FORM_CONTAINER_NAME].values || {};

    const data = new FormData();
    //TODO this not generic as whised because it relies in uploadAction requires
    //the value of user_id field to be present
    data.append('slid', values.user_id);

    for (let i = 0; i < files.length; i++) {
      if (
        /^(.*\.(?!(jpg|jpeg|png|pdf|doc|docx)$))?[^.]*$/i.test(files[i].name)
      ) {
        dispatch(fileUploadError());
        return Promise.reject(false);
      } else {
        data.append('files', files[i]);
      }
    }

    dispatch(fileUploadStart());

    const config: RequestInit = {
      method: 'POST',
      credentials: 'same-origin',
      body: data
    };

    try {
      const response = await fetch(uploadAction, config);

      if (response.status === 200) {
        return dispatch(fileUploadSuccess());
      } else {
        const error = await response.text();
        throw Error(error);
      }
    } catch (error) {
      dispatch(fileUploadError());
      return Promise.reject();
    }
  };
}

export function selectFiles(selectedFiles: ReadonlyArray<any>): SelectFiles {
  return {
    type: SELECT_FILES,
    selectedFiles
  };
}

export function removeFile(index: number): RemoveFiles {
  return {
    type: REMOVE_FILES,
    index
  };
}

export function selectSingleFile(
  selectedFile: any,
  index: number
): SelectSingleFile {
  return {
    type: SELECT_SINGLE_FILE,
    selectedFile,
    index
  };
}

export function removeSingleFile(index: number): RemoveSingleFile {
  return {
    type: REMOVE_SINGLE_FILE,
    index
  };
}
